export default __webpack_public_path__ + "src/static/docs/Certificate_Global_Bridge_Connection_2023.pdf";